import axios from "axios";

const BASE_INSURED_ASSETS_URL = "/api/insurance/insuredAssets"

export function getAvailableProducts(searchDate) {
    if (searchDate == null || searchDate === '') {
        return Promise.resolve();
    }
    return axios
        .get(`${BASE_INSURED_ASSETS_URL}/availableProducts`, { params: {
                searchDate: searchDate
            }})
        .then(result => result.data);
}

export function getInsuredAssets(productGroup, searchTerm, searchDate) {
    return axios
        .get(`${BASE_INSURED_ASSETS_URL}`, { params: {
                page: 0,
                sort: 'licensePlate,asc',
                search: searchTerm,
                status: true,
                productGroup: productGroup,
                searchDate: searchDate
            }})
        .then(result => result.data)
}

export function getInsuredLocations(productGroup, searchTerm, searchDate) {
    return axios
        .get(`${BASE_INSURED_ASSETS_URL}/location`, { params: {
                page: 0,
                sort: 'none',
                search: searchTerm,
                status: true,
                productGroup: productGroup,
                searchDate: searchDate
            }})
        .then(result => result.data)
}